import Image from "next/image"

export function Logo() {
  return (
    <Image
      alt='Marketplace Triibo'
      className='min-w-20'
      height={100}
      src='/static/img/logo.png'
      width={200}
    />
  )
}
